var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-main',[_c('perform-password-reset',_vm._b({directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"token":_vm.token}},'perform-password-reset',_vm.$data,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }